import React from "react";
import { ChevronRight } from "lucide-react";
import "./CloseOutOutcomeList.scss";

export const OUTCOMES = [
  { id: "found", label: "Closed" },
  { id: "under_contract", label: "Under Contract" },
  { id: "paused", label: "Archived, buyer paused" },
  {
    id: "not_working_with_buyer",
    label: "Archived, no longer working with this buyer",
  },
];

const Row = ({ label, onClick, disabled, danger, rowRef }) => (
  <button
    type="button"
    ref={rowRef}
    className={`close-out-row${danger ? " close-out-row--danger" : ""}`}
    onClick={onClick}
    disabled={disabled}
  >
    <span className="close-out-row__label">{label}</span>
    {!danger && (
      <ChevronRight
        className="close-out-row__chevron"
        size={18}
        aria-hidden="true"
      />
    )}
  </button>
);

const CloseOutOutcomeList = ({ onPick, onRemove, busy, firstRowRef }) => (
  <>
    <ul className="close-out-list" aria-labelledby="close-out-title">
      {OUTCOMES.map((o, index) => (
        <li key={o.id}>
          <Row
            rowRef={index === 0 ? firstRowRef : undefined}
            label={busy === o.id ? "Saving..." : o.label}
            disabled={!!busy}
            onClick={() => onPick(o.id)}
          />
        </li>
      ))}
    </ul>
    <div className="close-out-list__divider" role="presentation" />
    <Row
      label="Remove without an outcome"
      danger
      disabled={!!busy}
      onClick={onRemove}
    />
  </>
);

export default CloseOutOutcomeList;
